import { h } from 'preact';
import OptOutMainComponent, { OptOutMainPropsType } from './index';

export default class OptOutSmallIcon extends OptOutMainComponent<
  OptOutMainPropsType
> {
  render() {
    const { iconSize = '16px', iconColor, iconStyle = {} } = this.props;
    return (
      <div
        id="OptOutSmallIcon"
        data-zone="optout"
        onTouchStart={e => e.stopPropagation()}
        onClick={e => {
          e.stopPropagation();
          this.onClick(e);
        }}
      >
        <svg
          width={iconSize}
          height={iconSize}
          viewBox="0 0 16 16"
          style={iconStyle}
        >
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g fill-rule="nonzero">
              <path
                fill={iconColor}
                d="M8,0 C3.58076923,0 0,3.58076923 0,8 C0,12.4192308 3.58076923,16 8,16 C12.4192308,16 16,12.4192308 16,8 C16,3.58076923 12.4192308,0 8,0 Z M7.97209654,14.994448 C3.91295314,15 1,12.0644083 1,7.997224 C1,3.97915444 3.90912232,1 7.97209654,1 C11.9653416,1 15,3.97530981 14.9441931,7.997224 C15,12.0605637 11.9653416,15 7.97209654,14.994448 Z"
              />
              <g fill={iconColor} transform="translate(6.500000, 3.500000)">
                <circle cx="1.25" cy="1.25" r="1" />
                <polygon points="2 7 2 3 0 3 0 4 1 4 1 7 0 7 0 8 3 8 3 7" />
              </g>
            </g>
          </g>
        </svg>
      </div>
    );
  }
}
